import { MaybeJwtUser } from "shared-ui/utils/tokens";
import { MenuAnalyticsEventProps } from "../../../reporting/events";
import { SharedAnalyticsFilters } from "./useAnalyticsFilters";

// Builds the property bag shared by every Menu Analytics tracking event from the
// signed-in user and the active filter selections. Custom ranges also carry the
// explicit start/end dates; preset ranges omit them (resolved server-side).
export const buildMenuAnalyticsEventProps = (
  user: MaybeJwtUser,
  filters: SharedAnalyticsFilters
): MenuAnalyticsEventProps => ({
  userId: user?.id,
  organizationId: user?.orgMembership?.org.id,
  timeRange: filters.timeRange,
  mealPeriod: filters.mealPeriod,
  ...(filters.timeRange === "custom" && filters.startDate && filters.endDate
    ? { startDate: filters.startDate, endDate: filters.endDate }
    : {}),
});
